import { apiDelete, apiGet, apiPost, apiPut, buildFormData } from '@api/api.utils'
import { IResponseAddressSuggestions, IResponseCommon } from "../common.types"
import {
    IResponseCompanies,
    IResponseCompaniesCard,
    IResponseCompanyCheckField,
    IResponseCompanySave,
    IResponseFetchSuggestions,
    IResponseListenerFiles,
} from "./api.types"
import { ICompanyFormSendedData } from "./state.types"


const route = '/companies'

export const getCompanyAddressSuggestions = (query: string, signal?: AbortSignal): Promise<IResponseAddressSuggestions> =>
    apiPost<IResponseAddressSuggestions>(`${route}/getCompanyAddressSuggestions`, { signal }, { query })

/** Поиск контрагента в ЕГРЮЛ по ИНН И КПП */
export const getSearchCompany = (inn: string, kpp: string): Promise<IResponseFetchSuggestions> =>
    apiGet<IResponseFetchSuggestions>(`${route}/getSearchCompany`, { params: { inn, kpp } })

/** Проверка по ИНН, существование контрагента */
export const getCompanyCheckINN = (companyID: number, inn: string): Promise<IResponseCompanyCheckField> =>
    apiGet<IResponseCompanyCheckField>(`${route}/getCompanyCheckINN`, { params: { companyID, inn } })

/** Проверка по КПП, существование контрагента */
export const getCompanyCheckKPP = (companyID: number, kpp: string): Promise<IResponseCompanyCheckField> =>
    apiGet<IResponseCompanyCheckField>(`${route}/getCompanyCheckKPP`, { params: { companyID, kpp } })



/** Получение списка контрагентов */
export const getCompanies = (pageNumber: number, search?: string, signal?: AbortSignal): Promise<IResponseCompanies> =>
    apiGet<IResponseCompanies>(`${route}/getCompanies`, { params: { pageNumber, search }, signal })

/** Получение списка файлов контрагента */
export const getCompanyFiles = (companyID: number): Promise<IResponseListenerFiles> =>
    apiGet<IResponseListenerFiles>(`${route}/getCompanyFiles`, { params: { companyID } })



/** Получение данных по анкете контрагента */
export const getCompanyCard = (companyID: number): Promise<IResponseCompaniesCard> =>
    apiGet<IResponseCompaniesCard>(`${route}/getCompanyCard`, { params: { companyID } })

/** Сохранение данных по анкете контрагента */
export const setCompanyCardSave = (companyID: number, data: ICompanyFormSendedData, files?: File[]): Promise<IResponseCompanySave> =>
    apiPut<IResponseCompanySave>(
        `${route}/setCompanyCardSave`,
        {
            params: { companyID },
            headers: { 'Content-Type': 'multipart/form-data' },
        },
        buildFormData({ companyData: JSON.stringify(data), docs: files })
    )



/** Удаление файлов контрагента */
export const setCompanyDeleteFiles = (companyID: number, fileID: number): Promise<IResponseCommon> =>
    apiDelete<IResponseCommon>(`${route}/setCompanyDeleteFiles`, { params: { companyID, fileID } })

/** Загрузка файлов контрагента */
export const setCompanyUploadFiles = (companyID: number, files: File[]): Promise<IResponseCommon> =>
    apiPost<IResponseCommon>(
        `${route}/setCompanyUploadFiles`,
        {
            params: { companyID },
            headers: { 'Content-Type': 'multipart/form-data' },
        },
        buildFormData({ docs: files })
    )